import React from 'react'
import { Segment, Header } from 'semantic-ui-react'
import AppInboxForm from './components/form'

const EditAppInbox = props => {
  const { location } = props
  const { appInboxData } = location.state
  const firebaseKey = appInboxData.id

  return (
    <div>
      <Segment color="black">
        <Header size="large">Edit In-App Inbox</Header>
        <AppInboxForm firebaseKey={firebaseKey} action="edit" appInboxData={appInboxData} />
      </Segment>
    </div>
  )
}

export default EditAppInbox



// WEBPACK FOOTER //
// ./src/containers/appInbox/edit.js